<template>
  <div class="agent-corp-mail" v-if="corpMailData">   
    <div class="corp-mail-content">
      <div class="mail-info">
        <div class="mail-field">
          <label>Email:</label>
          <div class="mail-value">
            <span>{{ corpMailData.email }}</span>
            <button 
              class="copy-btn" 
              @click="copyToClipboard(corpMailData.email)"
              title="Скопировать email"
            >
              <i class="fas fa-copy"></i>
            </button>
          </div>
        </div>
        
        <div class="mail-field">
          <label>Пароль:</label>
          <div class="mail-value">
            <span v-if="!showPassword">{{ maskedPassword }}</span>
            <span v-else>{{ corpMailData.password }}</span>
            <button 
              class="toggle-password-btn" 
              @click="togglePassword"
              :title="showPassword ? 'Скрыть пароль' : 'Показать пароль'"
            >
              <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
            <button 
              class="copy-btn" 
              @click="copyToClipboard(corpMailData.password)"
              title="Скопировать пароль"
            >
              <i class="fas fa-copy"></i>
            </button>
          </div>
        </div>
        
      </div>
<!--       
      <div class="mail-status" :class="{ 'active': corpMailData.is_active, 'inactive': !corpMailData.is_active }">
        <i :class="corpMailData.is_active ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
        <span>{{ corpMailData.is_active ? 'Активна' : 'Неактивна' }}</span>
      </div> -->
    </div>
    
    <div class="corp-mail-footer">
      <small class="text-muted">
        <template v-if="isNicDomain">
          Для доступа к своему почтовому ящику используйте <a href="https://www.mail.nic.ru" target="_blank">https://www.mail.nic.ru</a>
        </template>
        <template v-else>
          Войти в ваш корпоративный почтовый ящик можно по ссылке: <a href="https://mail.yandex.ru/" target="_blank">https://mail.yandex.ru/</a>
        </template>
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentCorpMail',
  props: {
    corpMailData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPassword: false
    };
  },
  computed: {
    isNicDomain() {
      const email = (this.corpMailData && this.corpMailData.email) || '';
      const [, domain = ''] = email.split('@');
      return domain.toLowerCase() === 'corp.eu-tanais.com';
    },
    maskedPassword() {
      if (!this.corpMailData || !this.corpMailData.password) return '';
      return '*'.repeat(this.corpMailData.password.length);
    }
  },
  methods: {
    
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.success('Скопировано в буфер обмена');
      } catch (error) {
        // Fallback для старых браузеров
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$toast.success('Скопировано в буфер обмена');
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.agent-corp-mail {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.corp-mail-content {
  margin-bottom: 15px;
}

.mail-info {
  margin-bottom: 15px;
}

.mail-field {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 15px;
}

.mail-field label {
  font-weight: 600;
  color: #555;
  min-width: 120px;
  margin: 0;
}

.mail-value {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.mail-value span {
  font-family: 'Courier New', monospace;
  background: #f8f9fa;
  padding: 6px 10px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  flex: 1;
  word-break: break-all;
}

.copy-btn, .toggle-password-btn {
  background: #0d6348;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
}

.copy-btn:hover, .toggle-password-btn:hover {
  background: #168763;
}

.toggle-password-btn {
  background: #6c757d;
}

.toggle-password-btn:hover {
  background: #545b62;
}

.mail-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 500;
}

.mail-status.active {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.mail-status.inactive {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.corp-mail-footer {
  border-top: 1px solid #e9ecef;
  padding-top: 10px;
}

.text-muted {
  color: #6c757d;
  font-size: 12px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .mail-field {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .mail-field label {
    min-width: auto;
  }
  
  .mail-value {
    width: 100%;
  }
}
</style>
